import _ from 'lodash';
import { log } from '@elixir/logger';

let DisplayKeys = {};
try {
    DisplayKeys = require('translationsDisplayKeys');
} catch (err) {
    log.warning('Could not load translations');
}
/**
 * Translates the l10n key if provided in the resources, otherwise returns the 'displaykey not found'
 *
 * @param {String} key - display key to be translated
 * @returns {string} translated message or 'displaykey not found'
 */
export const translateDisplayKey = (key) => {
    if (DisplayKeys.hasOwnProperty(key)) {
        return DisplayKeys[key];
    }
    return 'displaykey not found';
};

/**
 * Translates the l10n key if provided in the resources, otherwise returns the key
 * (applies the string interpolation if needed)
 *
 * @param {String} key - display key to look up, supports also {Object} key - {id: key, defaultMessage: defaultMessage}
 * @param {Object} [args] - optional arguments to apply to the display key
 * @returns {String} translated message or the key
 *
 * @example
 * const key = 'messages.cancel';
 * const reason: {reason: 'Weather'};
 * translateDisplayKeyWithFallback(key, defaultMessage, reason);
 * translateDisplayKeyWithFallback({id: key, defaultMessage:'Cancel'}, reason);
 */
export const translateDisplayKeyWithFallback = (key, ...args) => {
    if (!isKeySupportedByTranslator(key)) {
        return key;
    }
    if (_.isString(key)) {
        return translateResolvedDisplayKey(key, null, args);
    }
    return translateResolvedDisplayKey(key.id, key.defaultMessage, args);
};

const translateResolvedDisplayKey = (key, defaultMessage, args) => {
    let result;
    if (DisplayKeys.hasOwnProperty(key)) {
        result = DisplayKeys[key];
    } else {
        result = defaultMessage || key;
    }
    if (args.length) {
        args.forEach((value, index) => {
            if (_.isObject(value)) {
                _.keys(value).forEach(valueKey => {
                    result = result.replace(`{{${valueKey}}}`, value[valueKey]);
                });
            } else {
                result = result.replace(`{{_${index}}}`, value);
            }
        });
    }
    return result;
};

const isKeySupportedByTranslator = obj => _.isString(obj) || isIntlMessage(obj);
const isIntlMessage = obj => _.isObject(obj) && _.isString(obj.id) && _.isString(obj.defaultMessage);

export default translateDisplayKeyWithFallback;
